module.exports = __webpack_public_path__ + "img/ind.357c927f.jpg";